<span
  class="status-badge"
  [class]="'status-badge--' + type"
  [class.status-badge--small]="size === 'small'"
  [class.status-badge--large]="size === 'large'"
  [class.status-badge--rounded]="rounded"
  [class.status-badge--outline]="outline">
  <i *ngIf="icon" [class]="icon" class="status-badge__icon"></i>
  <span class="status-badge__label">{{ label }}</span>
</span>
